import type { SearchPolicyParams } from "../hooks/useSearchPolicy";

export type PartialPolicySearchParams = Partial<SearchPolicyParams>;

const policySearchParamNames = {
  policynumber: "policyNumber",
  postcode: "postcode",
  lastname: "lastName",
} as const;

const isPolicySearchParamName = (
  name: string,
): name is keyof typeof policySearchParamNames =>
  Object.prototype.hasOwnProperty.call(policySearchParamNames, name);

export const getPolicySearchParams = (
  urlParams: URLSearchParams,
): PartialPolicySearchParams => {
  const policySearchParams: PartialPolicySearchParams = {};

  urlParams.forEach((value, key) => {
    const normalizedKey = key.toLowerCase();
    const normalizedValue = value.trim().toLowerCase();

    if (isPolicySearchParamName(normalizedKey) && normalizedValue) {
      policySearchParams[policySearchParamNames[normalizedKey]] = value.trim();
    }
  });

  return policySearchParams;
};

export const hasCompletePolicySearchParams = (
  searchParams: PartialPolicySearchParams,
): searchParams is SearchPolicyParams =>
  [
    searchParams.policyNumber,
    searchParams.postcode,
    searchParams.lastName,
  ].every((value) => !!value?.trim().toLowerCase());

export const stripPolicySearchParams = (url: string) => {
  try {
    const parsedUrl = new URL(url);

    Array.from(parsedUrl.searchParams.keys()).forEach((key) => {
      if (isPolicySearchParamName(key.toLowerCase())) {
        parsedUrl.searchParams.delete(key);
      }
    });

    return parsedUrl.toString();
  } catch {
    return url;
  }
};
